export default "__VITE_ASSET__7vfdo0jS__"